import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import { Mdx, Image } from '@ta-interaktiv/contentbricks'
import { Statement, Props as StatementProps } from '../statement'
import { CO2Viz, Props as VizProps } from '../co2viz'

import './styles.scss'

export interface Props {
  name: string
  direction: string
  statement: string
  reason: string
  flight: string[]
  image: string | string[]
  map: string
  text: string
  perCapita: number
  show: string[]
  compensation: {
    [key: string]: [number, string]
    trees: [number, string]
    meat: [number, string]
    cars: [number, string]
    baskets: [number, string]
  }
}

export const Person = ({
  name,
  direction,
  statement,
  image,
  reason,
  flight,
  map,
  text,
  perCapita,
  compensation,
  show
}: Props) => {
  const vizProps: VizProps = {
    flight,
    map,
    perCapita,
    compensation,
    show
  }
  const statementProps: StatementProps = {
    statement,
    direction
  }
  return (
    <>
      <div className='ui vertical segment' id='person'>
        <div className='ui  container'>
          <div className='ui text container'>
            <div className='name'>
              <b>{name} </b>
              <br />
              {reason}
            </div>
          </div>
        </div>
        <div className='ui container'>
          <div id='personIntro'>
            <div className='portrait'>
              <Image file={image} />
            </div>
            <Statement {...statementProps} />
          </div>
        </div>
      </div>

      <div className='ui vertical segment' id='personText'>
        <div className='ui text container'>
          <Mdx file={text} />
        </div>
        <CO2Viz {...vizProps} />
      </div>
    </>
  )
}
